import { Alert, Button, Checkbox, Paper, TextField, Typography } from "@mui/material";
import { Box, Grid, height, minWidth, useMediaQuery, useTheme } from "@mui/system";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useState, useMemo } from "react";
import NoDataComponent from "./NoDataComponent";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import dataGridSx from "../theme/datagridTheme";

// =========================
// SELECTED BILL CARD 
// =========================
const SelectedBillCard = ({ row, isAdvanceViewMode, paymentType, activeField, setActiveField, handleDeselectInvoice, handleBillFieldChange, allowPositiveDecimal }) => {
    const total = (parseFloat(row.inputAmount) || 0) + (parseFloat(row.inputTds) || 0) + (parseFloat(row.inputRoundOff) || 0);
    const osAmt = parseFloat(row.OSAmt || 0);
    const isError = total > osAmt;

    return (
        <Box sx={{ border: `1px solid ${isError ? "#f44336" : "#e0e0e0"}`, borderRadius: 2, p: 1.5, mb: 1.2, bgcolor: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>

            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Checkbox
                    size="small"
                    checked={true}
                    onChange={() => handleDeselectInvoice(row)}
                    disabled={isAdvanceViewMode}
                    sx={{ p: 0.5, mr: 0.5 }}
                />
                <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography sx={{ fontWeight: 700, fontSize: "0.88rem" }}>{row.BillNumber}</Typography>
                        <Typography sx={{ fontSize: "0.75rem", color: "#888" }}>
                            {row.BillDate ? new Date(row.BillDate).toLocaleDateString("en-GB") : ""}
                        </Typography>
                    </Box>
                    <Typography sx={{ fontSize: "0.75rem", color: "#666", mt: 0.2 }}>{row.BookName}</Typography>
                </Box>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1, px: 0.5 }}>
                <Typography sx={{ fontSize: "0.75rem", color: "#999", fontWeight: 600, textTransform: "uppercase" }}>O/S Amount</Typography>
                <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, color: "#1976d2" }}>{osAmt.toFixed(2)}</Typography>
            </Box>

            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}>

                <Box>
                    <Typography sx={{ fontSize: "0.7rem", color: "#666", mb: 0.3, fontWeight: 500 }}>Amount</Typography>
                    <TextField
                        size="small" fullWidth type="text"
                        value={row.inputAmount}
                        disabled={isAdvanceViewMode}
                        onChange={(e) => { const value = allowPositiveDecimal(e.target.value); handleBillFieldChange(row.invoiceId, "inputAmount", value); }}
                        onFocus={() => setActiveField(`${row.invoiceId}-inputAmount`)}
                        error={isError && row.inputAmount !== ""}
                        helperText={isError && row.inputAmount !== "" && activeField === `${row.invoiceId}-inputAmount` ? "Exceeds o/s amt" : ""}
                        inputProps={{ inputMode: "numeric", style: { textAlign: "right", padding: "4px 8px" } }}
                        FormHelperTextProps={{ sx: { m: 0, mt: "2px", lineHeight: 1, height: "14px", overflow: "hidden", textAlign: "center" } }}
                        sx={{ "& .MuiInputBase-root": { borderRadius: "4px" } }}
                    />
                </Box>

                {paymentType !== "Advance" && (
                    <Box>
                        <Typography sx={{ fontSize: "0.7rem", color: "#666", mb: 0.3, fontWeight: 500 }}>TDS</Typography>
                        <TextField
                            size="small" fullWidth type="text"
                            value={row.inputTds}
                            onChange={(e) => { const value = allowPositiveDecimal(e.target.value); handleBillFieldChange(row.invoiceId, "inputTds", value); }}
                            onFocus={() => setActiveField(`${row.invoiceId}-inputTds`)}
                            error={isError && row.inputTds !== ""}
                            helperText={isError && row.inputTds !== "" && activeField === `${row.invoiceId}-inputTds` ? "Exceeds o/s amt" : ""}
                            inputProps={{ inputMode: "numeric", style: { textAlign: "right", padding: "4px 8px" } }}
                            FormHelperTextProps={{ sx: { m: 0, mt: "2px", lineHeight: 1, height: "14px", overflow: "hidden", textAlign: "center" } }}
                            sx={{ "& .MuiInputBase-root": { borderRadius: "4px" } }}
                        />
                    </Box>
                )}

                {paymentType !== "Advance" && (
                    <Box>
                        <Typography sx={{ fontSize: "0.7rem", color: "#666", mb: 0.3, fontWeight: 500 }}>Round Off</Typography>
                        <TextField
                            size="small" fullWidth type="text"
                            value={row.inputRoundOff}
                            disabled={isAdvanceViewMode}
                            onChange={(e) => { const value = allowPositiveDecimal(e.target.value); handleBillFieldChange(row.invoiceId, "inputRoundOff", value); }}
                            onFocus={() => setActiveField(`${row.invoiceId}-inputRoundOff`)}
                            error={isError && row.inputRoundOff !== ""}
                            helperText={isError && row.inputRoundOff !== "" && activeField === `${row.invoiceId}-inputRoundOff` ? "Exceeds o/s amt" : ""}
                            inputProps={{ inputMode: "numeric", style: { textAlign: "right", padding: "4px 8px" } }}
                            FormHelperTextProps={{ sx: { m: 0, mt: "2px", lineHeight: 1, height: "14px", overflow: "hidden", textAlign: "center" } }}
                            sx={{ "& .MuiInputBase-root": { borderRadius: "4px" } }}
                        />
                    </Box>
                )}

                {paymentType !== "Advance" && (
                    <Box>
                        <Typography sx={{ fontSize: "0.7rem", color: "#666", mb: 0.3, fontWeight: 500 }}>Total Amount</Typography>
                        <TextField
                            size="small" fullWidth type="text"
                            value={total.toFixed(2)}
                            disabled
                            inputProps={{ style: { textAlign: "right", padding: "4px 8px" } }}
                            sx={{ "& .MuiInputBase-root": { borderRadius: "4px", bgcolor: "#f5f5f5" } }}
                        />
                    </Box>
                )}
            </Box>

            {isError && (
                <Typography sx={{ fontSize: "0.72rem", color: "error.main", mt: 0.5, textAlign: "right" }}>
                    Total exceeds O/S amount
                </Typography>
            )}
        </Box>
    );
};

const PaymentReceiptStepTwo = ({ invoiceData, selectedBills, pendingSelectedIds, handleAutoSelectBills, setPendingSelectedIds, loadingInvoices, handleSubmitSelected, modalOpen, setModalOpen, paymentType, handleSave, handleClear, disableSave, handleDeselectInvoice, handleBillFieldChange, errors, amount, goback, tds,
    roundOff, totalAmt, isBillsReset, isEditMode, handleResetBills }) => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down("sm"));

    const [activeField, setActiveField] = useState(null);

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    console.log("selectedBills", selectedBills)

    const selectedPendingTotal = invoiceData
        .filter(row => pendingSelectedIds.includes(row.invoiceId))
        .reduce((sum, row) => sum + (parseFloat(row.OSAmt) || 0), 0);

    console.log("invoiceData", invoiceData)


    const disableBillModification =
        isEditMode &&
        selectedBills.length > 0 &&
        !isBillsReset;


    const isAdvanceViewMode =
        paymentType === "Advance";


    // const isAlreadySelected = (row) => {
    //     return selectedBills.some(
    //         (bill) => bill.invoiceId === row.invoiceId
    //     );
    // };

    const isAlreadySelected = (row) => {
        return selectedBills.some((bill) => {
            const total =
                (parseFloat(bill.inputAmount) || 0) +
                (parseFloat(bill.inputTds) || 0) +
                (parseFloat(bill.inputRoundOff) || 0);

            return (
                bill.invoiceId === row.invoiceId &&
                total > 0
            );
        });
    };



    const pendingColumns = useMemo(() => [
        {
            field: "select",
            headerName: "",
            flex: 0.5,
            sortable: false,
            filterable: false,
            headerClassName: "data-grid-header",

            // ✅ HEADER CHECKBOX (SELECT ALL)
            renderHeader: () => {
                const allIds = invoiceData?.map((row) => row.invoiceId) || [];
                const isAllSelected =
                    allIds.length > 0 &&
                    allIds.every((id) => pendingSelectedIds.includes(id));

                return (
                    <Checkbox
                        checked={isAllSelected}
                        // disabled={disableBillModification}
                        indeterminate={
                            pendingSelectedIds.length > 0 && !isAllSelected
                        }
                        onChange={(e) => {
                            if (e.target.checked) {
                                setPendingSelectedIds(allIds); // select all
                            } else {
                                setPendingSelectedIds([]); // clear all
                            }
                        }}
                    />
                );
            },

            // ✅ ROW CHECKBOX
            // renderCell: (params) => {
            //     const id = params.row.invoiceId;

            //     return (
            //         <Checkbox
            //             checked={pendingSelectedIds.includes(id)}
            //             onChange={(e) => {
            //                 setPendingSelectedIds((prev) =>
            //                     e.target.checked
            //                         ? [...prev, id]
            //                         : prev.filter((selectedId) => selectedId !== id)
            //                 );
            //             }}
            //         />
            //     );
            // },

            renderCell: (params) => {

                const id = params.row.invoiceId;

                const alreadySelected =
                    isAlreadySelected(params.row);

                return (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "100%"
                        }}
                    >
                        <Checkbox
                            checked={
                                alreadySelected
                                    ? true
                                    : pendingSelectedIds.includes(id)
                            }
                            disabled={
                                // disableBillModification ||
                                alreadySelected
                            }
                            onChange={(e) => {

                                if (alreadySelected) return;

                                setPendingSelectedIds((prev) =>
                                    e.target.checked
                                        ? [...prev, id]
                                        : prev.filter(
                                            (selectedId) =>
                                                selectedId !== id
                                        )
                                );
                            }}
                        />

                        {alreadySelected && (
                            <Typography
                                variant="caption"
                                color="error"
                                sx={{
                                    fontSize: "10px",
                                    lineHeight: 1,
                                    mt: "-4px"
                                }}
                            >
                                Already Selected
                            </Typography>
                        )}
                    </Box>
                );
            }
        },
        { field: "BillNumber", headerName: "Bill No", flex: 1, headerClassName: "data-grid-header", cellClassName: "data-grid-cell", },
        { field: "BookName", headerName: "Book Name", flex: 1, headerClassName: "data-grid-header", cellClassName: "data-grid-cell", },
        {
            field: "BillDate", headerName: "Bill Date", flex: 0.9, headerClassName: "data-grid-header", cellClassName: "data-grid-cell",
            valueFormatter: (value) => {
                if (!value) return "";

                const date = new Date(value);

                if (isNaN(date)) return value;

                return date.toLocaleDateString("en-GB");
            }
        },
        {
            field: "OSAmt",
            headerName: "O/S Amount",
            flex: 1,
            type: "number",
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => {
                console.log("formatter value: OSAmt", value);
                return parseFloat(value).toFixed(2);
            },
            headerClassName: "data-grid-header",
            cellClassName: "data-grid-cell",
        },
        // {
        //     field: "PaidAmt",
        //     headerName: "Paid Amt",
        //     flex: 1,
        //     type: "number",
        //     headerAlign: "right",
        //     align: "right",
        //     valueFormatter: (value) => parseFloat(value).toFixed(2),
        //     headerClassName: "data-grid-header",
        //     cellClassName: "data-grid-cell",
        // },
        {
            field: "DueDate", headerName: "Due Date", flex: 0.9, headerClassName: "data-grid-header", cellClassName: "data-grid-cell",
            valueFormatter: (value) => {
                if (!value) return "";

                const date = new Date(value);

                if (isNaN(date)) return value;

                return date.toLocaleDateString("en-GB");
            }
        },
    ], [invoiceData, pendingSelectedIds, isAlreadySelected, setPendingSelectedIds]);

    const allowPositiveDecimal = (value) => {
        // remove everything except digits and dot
        let cleaned = value.replace(/[^0-9.]/g, "");

        // allow only ONE decimal point
        const parts = cleaned.split(".");
        if (parts.length > 2) {
            cleaned = parts[0] + "." + parts.slice(1).join("");
        }

        return cleaned;
    };


    const PendingInvoiceCard = ({ row }) => {
        const id = row.invoiceId;
        const alreadySelected = isAlreadySelected(row);
        const isChecked = alreadySelected ? true : pendingSelectedIds.includes(id);

        return (
            <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 1.5, mb: 1.2, bgcolor: alreadySelected ? "#f5f5f5" : "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>

                <Box sx={{ display: "flex", alignItems: "flex-start", mb: 0.8 }}>
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mr: 1 }}>
                        <Checkbox
                            size="small"
                            checked={isChecked}
                            disabled={alreadySelected}
                            onChange={(e) => {
                                if (alreadySelected) return;
                                setPendingSelectedIds((prev) =>
                                    e.target.checked
                                        ? [...prev, id]
                                        : prev.filter((selectedId) => selectedId !== id)
                                );
                            }}
                            sx={{ p: 0.5 }}
                        />
                        {alreadySelected && (
                            <Typography sx={{ fontSize: "9px", color: "error.main", lineHeight: 1, textAlign: "center" }}>
                                Already Selected
                            </Typography>
                        )}
                    </Box>

                    <Box sx={{ flex: 1 }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography sx={{ fontWeight: 700, fontSize: "0.88rem" }}>
                                {row.BillNumber}
                            </Typography>
                            <Typography sx={{ fontSize: "0.75rem", color: "#888" }}>
                                {row.BillDate ? new Date(row.BillDate).toLocaleDateString("en-GB") : ""}
                            </Typography>
                        </Box>
                        <Typography sx={{ fontSize: "0.75rem", color: "#666", mt: 0.3 }}>
                            {row.BookName}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", pl: 5 }}>
                    <Box>
                        <Typography sx={{ fontSize: "0.7rem", color: "#999", fontWeight: 600, textTransform: "uppercase" }}>
                            O/S Amount
                        </Typography>
                        <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, color: "#1976d2" }}>
                            {parseFloat(row.OSAmt || 0).toFixed(2)}
                        </Typography>
                    </Box>
                    <Box sx={{ textAlign: "right" }}>
                        <Typography sx={{ fontSize: "0.7rem", color: "#999", fontWeight: 600, textTransform: "uppercase" }}>
                            Due Date
                        </Typography>
                        <Typography sx={{ fontSize: "0.82rem" }}>
                            {row.DueDate ? new Date(row.DueDate).toLocaleDateString("en-GB") : "-"}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        );
    };

    const selectedColumns = useMemo(() => [
        {
            field: "select",
            headerName: "Sr No",
            flex: 0.6,
            sortable: false,
            filterable: false,
            headerClassName: "data-grid-header",

            // Row checkbox (deselect single)
            renderCell: (params) => (
                <Checkbox
                    checked={true}
                    onChange={() => handleDeselectInvoice(params.row)}
                    disabled={isAdvanceViewMode}
                />
            ),
        },

        {
            field: "BillNumber",
            headerName: "Invoice No",
            flex: 1,
            headerClassName: "data-grid-header",
            cellClassName: "data-grid-cell",
        },
        {
            field: "BookName",
            headerName: "Book Name",
            flex: 0.8,
            headerClassName: "data-grid-header",
            cellClassName: "data-grid-cell",
        },
        {
            field: "BillDate",
            headerName: "Bill Date",
            flex: 0.8,
            minWidth: 90,
            headerClassName: "data-grid-header",
            cellClassName: "data-grid-cell",
            valueFormatter: (value) => {
                if (!value) return "";

                const date = new Date(value);

                if (isNaN(date)) return value;

                return date.toLocaleDateString("en-GB");
            }
        },
        // {
        //     field: "BasicAmt",
        //     headerName: "Basic Amount",
        //     flex: 1,
        //     type: "number",
        //     headerAlign: "right",
        //     align: "right",
        //     valueFormatter: (value) => parseFloat(value).toFixed(2),
        //     headerClassName: "data-grid-header",
        //     cellClassName: "data-grid-cell",
        // },
        // {
        //     field: "RoundOff",
        //     headerName: "Round Off",
        //     flex: 0.5,
        //     type: "number",
        //     headerAlign: "right",
        //     align: "right",
        //     valueFormatter: (value) => parseFloat(value).toFixed(2),
        //     headerClassName: "data-grid-header",
        //     cellClassName: "data-grid-cell",
        // },
        {
            field: "OSAmt",
            headerName: "O/S Amount",
            flex: 1,
            type: "number",
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => parseFloat(value).toFixed(2),
            headerClassName: "data-grid-header",
            cellClassName: "data-grid-cell",
        },
        // {
        //     field: "PaidAmt",
        //     headerName: "Paid Amt",
        //     flex: 1,
        //     type: "number",
        //     headerAlign: "right",
        //     align: "right",
        //     valueFormatter: (value) => parseFloat(value).toFixed(2),
        //     headerClassName: "data-grid-header",
        //     cellClassName: "data-grid-cell",
        // },
        {
            field: "inputAmount",
            headerName: "Amount",
            flex: 1,
            headerAlign: "right",
            align: "right",
            renderCell: (params) => {
                const isCurrentEmpty = params.row.inputAmount === "";

                const total =
                    (parseFloat(params.row.inputAmount) || 0) +
                    (parseFloat(params.row.inputTds) || 0) +
                    (parseFloat(params.row.inputRoundOff) || 0);

                const isError = !isCurrentEmpty && total > parseFloat(params.row.OSAmt);
                const fieldKey = `${params.row.invoiceId}-inputAmount`;

                return < TextField
                    size="small"
                    type="text"
                    sx={{
                        width: "100%",
                        "& .MuiInputBase-root": {
                            borderRadius: "4px",
                            "& input": {
                                textAlign: "right",
                                padding: "4px 6px",
                            },
                            width: "100%",
                            "& .MuiFormControl-root": {
                                margin: 0
                            }
                        },
                    }}
                    inputProps={{
                        type: "text",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        style: { MozAppearance: "textfield", appearance: "textfield" },
                    }}
                    value={params.row.inputAmount}
                    onChange={(e) => {
                        const value = allowPositiveDecimal(e.target.value);
                        handleBillFieldChange(params.row.invoiceId, "inputAmount", value);
                    }}
                    error={isError}
                    helperText={isError && activeField === fieldKey ? "Exceeds o/s amt" : ""}
                    onFocus={() =>
                        setActiveField(`${params.row.invoiceId}-inputAmount`)
                    }
                    disabled={isAdvanceViewMode}
                    FormHelperTextProps={{
                        sx: {
                            m: 0,
                            mt: "2px",
                            lineHeight: 1,
                            height: "14px",      // FIXED HEIGHT
                            overflow: "hidden",
                            textAlign: "center",
                        }
                    }}
                />
            },
            headerClassName: "data-grid-header",
            cellClassName: "data-grid-cell",
        },
        ...(
            paymentType !== "Advance"
                ? [{
                    field: "inputTds",
                    headerName: "TDS",
                    flex: 0.8,
                    headerAlign: "right",
                    align: "right",
                    renderCell: (params) => {

                        const isCurrentEmpty = params.row.inputTds === "";

                        const total =
                            (parseFloat(params.row.inputAmount) || 0) +
                            (parseFloat(params.row.inputTds) || 0) +
                            (parseFloat(params.row.inputRoundOff) || 0);

                        const isError = !isCurrentEmpty && total > parseFloat(params.row.OSAmt);
                        const fieldKey = `${params.row.invoiceId}-inputTds`;

                        return (
                            <TextField
                                size="small"
                                type="text"
                                sx={{
                                    width: "100%",
                                    "& .MuiInputBase-root": {
                                        borderRadius: "4px",
                                        "& input": {
                                            textAlign: "right",
                                            padding: "4px 6px",
                                            width: "100%",
                                            "& .MuiFormControl-root": {
                                                margin: 0
                                            }
                                        },
                                    },
                                }}
                                inputProps={{
                                    type: "text",
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                    style: {
                                        MozAppearance: "textfield",
                                        appearance: "textfield"
                                    },
                                }}
                                value={params.row.inputTds}
                                onChange={(e) => {
                                    const value = allowPositiveDecimal(e.target.value);
                                    handleBillFieldChange(
                                        params.row.invoiceId,
                                        "inputTds",
                                        value
                                    );
                                }}
                                onFocus={() =>
                                    setActiveField(
                                        `${params.row.invoiceId}-inputTds`
                                    )
                                }
                                error={isError}
                                helperText={
                                    isError &&
                                        activeField === fieldKey
                                        ? "Exceeds o/s amt"
                                        : ""
                                }
                                FormHelperTextProps={{
                                    sx: {
                                        m: 0,
                                        mt: "2px",
                                        lineHeight: 1,
                                        height: "14px",
                                        overflow: "hidden",
                                        textAlign: "center",
                                    }
                                }}
                            />
                        );
                    },
                    headerClassName: "data-grid-header",
                    cellClassName: "data-grid-cell",
                }]
                : []
        ), ,
        ...(
            paymentType !== "Advance"
                ? [{
                    field: "inputRoundOff",
                    headerName: "RoundOff",
                    flex: 0.7,
                    headerAlign: "right",
                    align: "right",
                    renderCell: (params) => {
                        const isCurrentEmpty = params.row.inputRoundOff === "";

                        const total =
                            (parseFloat(params.row.inputAmount) || 0) +
                            (parseFloat(params.row.inputTds) || 0) +
                            (parseFloat(params.row.inputRoundOff) || 0);

                        const isError =
                            !isCurrentEmpty &&
                            total > parseFloat(params.row.OSAmt);

                        const fieldKey =
                            `${params.row.invoiceId}-inputRoundOff`;

                        return (
                            <TextField
                                size="small"
                                type="text"
                                sx={{
                                    width: "100%",
                                    "& .MuiInputBase-root": {
                                        borderRadius: "4px",
                                        "& input": {
                                            textAlign: "right",
                                            padding: "4px 6px",
                                            width: "100%",
                                            "& .MuiFormControl-root": {
                                                margin: 0
                                            }
                                        },
                                    },
                                }}
                                disabled={isAdvanceViewMode}
                                inputProps={{
                                    type: "text",
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                    style: {
                                        MozAppearance: "textfield",
                                        appearance: "textfield"
                                    },
                                }}
                                value={params.row.inputRoundOff}
                                onChange={(e) => {
                                    const value = allowPositiveDecimal(
                                        e.target.value
                                    );

                                    handleBillFieldChange(
                                        params.row.invoiceId,
                                        "inputRoundOff",
                                        value
                                    );
                                }}
                                onFocus={() =>
                                    setActiveField(
                                        `${params.row.invoiceId}-inputRoundOff`
                                    )
                                }
                                error={isError}
                                helperText={
                                    isError &&
                                        activeField === fieldKey
                                        ? "Exceeds o/s amt"
                                        : ""
                                }
                                FormHelperTextProps={{
                                    sx: {
                                        m: 0,
                                        mt: "2px",
                                        lineHeight: 1,
                                        height: "14px",
                                        overflow: "hidden",
                                        textAlign: "center",
                                    }
                                }}
                            />
                        );
                    },
                    headerClassName: "data-grid-header",
                    cellClassName: "data-grid-cell",
                }]
                : []
        ),
        ...(
            paymentType !== "Advance"
                ? [{
                    field: "inputTotalAmount",
                    headerName: "Total Amount",
                    flex: 1.1,
                    headerAlign: "right",
                    align: "right",
                    renderCell: (params) => (
                        <TextField
                            size="small"
                            type="text"
                            sx={{
                                width: "100%",
                                "& .MuiInputBase-root": {
                                    borderRadius: "4px",
                                    "& input": {
                                        textAlign: "right",
                                        padding: "4px 8px",
                                    },
                                },
                            }}
                            inputProps={{
                                type: "text",
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                                style: {
                                    MozAppearance: "textfield",
                                    appearance: "textfield"
                                },
                            }}
                            value={(
                                (parseFloat(params.row.inputAmount) || 0) +
                                (parseFloat(params.row.inputTds) || 0) +
                                (parseFloat(params.row.inputRoundOff) || 0)
                            ).toFixed(2)}
                            disabled
                        />
                    ),
                    headerClassName: "data-grid-header",
                    cellClassName: "data-grid-cell",
                }]
                : []
        ),
    ], [activeField, allowPositiveDecimal, handleBillFieldChange, handleDeselectInvoice, isAdvanceViewMode, paymentType, setActiveField]);

    const dataGridSx = {
        // Column header styling
        '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#E0E0E0', minHeight: '45px !important',
            maxHeight: '45px !important',
        },
        '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 500 },
        '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', minHeight: '45px !important',
            maxHeight: '45px !important',
        },

        // Background styling
        '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
        '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },

        // Row styling
        '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
        '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
        '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },

        // Selected row styling (with !important to override default MUI)
        // '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },

        // Cell content alignment
        '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center'
        },
    }

    return (
        <Box>
            {/* 🔹 Pending Invoices */}
            {/* <Paper variant="outlined" sx={{ p: 2, mb: 2 }} >
                <Typography variant="subtitle1" fontWeight="bold">
                    Pending Invoices
                </Typography>
                <DataGrid
                    rows={invoiceData ?? []}
                    columns={pendingColumns ?? []}
                    getRowId={(row) => row.invoiceId}
                    autoHeight
                    disableColumnResize
                    loading={loadingInvoices}
                    hideFooter
                    disableRowSelectionOnClick
                      sx={dataGridSx}
                    rowHeight={isSm ? 48 : 52}
                />
                {invoiceData.length === 0 && !loadingInvoices && (
                    <Typography sx={{ textAlign: "center", fontSize: isSm ? "0.75rem" : "0.875rem", py: 1, color: "text.secondary" }}>
                        No Record Found…
                    </Typography>
                )}

                <Box sx={{ textAlign: "center", mt: 3 }}>
                    <Button onClick={handleSubmitSelected} disabled={pendingSelectedIds.length === 0} sx={{ fontSize: "0.875rem", padding: "0.5rem", mr: 2 }} variant="contained">View</Button>
                    <Button onClick={() => setOpen(false)} sx={{ fontSize: "0.875rem", padding: "0.5rem" }} variant="outlined">Cancel</Button>

                </Box>
            </Paper> */}
            {/* BillWise DataGrid */}
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0 }}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={goback}
                    size="small"
                    sx={{
                        mr: 2,
                        textTransform: "none",
                        fontWeight: 500,
                        borderRadius: 2,
                        paddingX: 1.5,
                        backgroundColor: "#e6e9ea",
                        color: "#333333",
                        "&:hover": {
                            backgroundColor: "#d6d9da",
                        },
                    }}
                >
                    Back
                </Button>

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
                    {!isAdvanceViewMode &&
                        isEditMode &&
                        paymentType === "BillWise" &&
                        selectedBills.length > 0 &&
                        !isBillsReset && (
                            <Button
                                color="error"
                                variant="outlined"
                                onClick={handleResetBills}
                            >
                                Remove All Bills
                            </Button>
                        )}

                    {!isAdvanceViewMode &&
                        <Button
                            variant="outlined"
                            onClick={handleAutoSelectBills}
                        >
                            Auto Select Bills
                        </Button>}

                    {isAdvanceViewMode && (
                        <Alert severity="warning" sx={{ borderRadius: 2, alignItems: "center" }} >
                            The advance has already been adjusted against invoices, so modifications are disabled.
                        </Alert>
                    )}

                    {!isAdvanceViewMode && <Button
                        variant="contained"
                        onClick={() => setModalOpen(true)}
                    >
                        Show Bills
                    </Button>}


                </Box>


            </Box>
            {(paymentType === "BillWise" || paymentType === "Advance") && (
                <Grid item xs={12}>
                    <Paper variant="outlined" sx={{ p: 1, boxShadow: "0 2px 4px rgba(0,0,0,0.1)", width: "100%", mt: 1, height: "64vh", display: "flex", flexDirection: "column", borderRadius: 2 }} >
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5, px: 1 }} >
                            <Typography variant="subtitle1" fontWeight="bold" sx={{ fontSize: isSm ? "0.875rem" : "1rem" }} >
                                Selected Bills
                            </Typography>

                            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", justifyContent: "flex-end", alignItems: "center" }} >
                                <Typography sx={{ fontWeight: 500 }}>
                                    Amount: {parseFloat(amount || 0).toFixed(2)}
                                </Typography>

                                {!isAdvanceViewMode && <Typography sx={{ fontWeight: 500 }} >
                                    TDS: {parseFloat(tds || 0).toFixed(2)}
                                </Typography>}

                                {!isAdvanceViewMode && <Typography sx={{ fontWeight: 500 }}>
                                    RoundOff: {parseFloat(roundOff || 0).toFixed(2)}
                                </Typography>}

                                {!isAdvanceViewMode && <Typography sx={{ fontWeight: "bold", color: "#1976d2" }}>
                                    Total: {parseFloat(totalAmt || 0).toFixed(2)}
                                </Typography>}


                            </Box>
                        </Box>
                        {isMobile ? (
                            <Box sx={{ flex: 1, overflowY: "auto", px: 0.5 }}>
                                {selectedBills.length === 0
                                    ? <NoDataComponent width={160} title1Variant="h6" />
                                    : selectedBills.map((row) => (
                                        <SelectedBillCard
                                            key={row.invoiceId}
                                            row={row}
                                            isAdvanceViewMode={isAdvanceViewMode}
                                            paymentType={paymentType}
                                            activeField={activeField}
                                            setActiveField={setActiveField}
                                            handleDeselectInvoice={handleDeselectInvoice}
                                            handleBillFieldChange={handleBillFieldChange}
                                            allowPositiveDecimal={allowPositiveDecimal}
                                        />
                                    ))
                                }
                            </Box>
                        ) : (
                            <DataGrid
                                rows={selectedBills ?? []}
                                columns={selectedColumns ?? []}
                                getRowId={(row) => row.invoiceId}
                                disableVirtualization
                                // getRowHeight={() => "auto"}
                                disableRowSelectionOnClick
                                disableColumnResize
                                pagination
                                pageSizeOptions={[10, 20, 30]}
                                initialState={{
                                    pagination: {
                                        paginationModel: { pageSize: 10, page: 0 },
                                    },
                                }}
                                sx={{
                                    ...dataGridSx, height: "100%",
                                    // 🔽 Reduce footer height
                                    '& .MuiDataGrid-footerContainer': { minHeight: 38, height: 38, overflowY: "hidden" },

                                    // 🔽 Reduce pagination toolbar height
                                    '& .MuiTablePagination-root': { minHeight: 38, height: 38, overflowY: "hidden" },

                                    // 🔽 Reduce rows-per-page + label spacing
                                    '& .MuiTablePagination-toolbar': { minHeight: 38, height: 38, padding: '0 8px', overflowY: "hidden" },

                                }}
                                rowHeight={isSm ? 48 : 52}
                                slots={{
                                    noRowsOverlay: () => (
                                        <NoDataComponent width={160} title1Variant="h6" />
                                    ),
                                }}
                            />
                        )}

                        {selectedBills.length > 0 && (
                            <Box sx={{ pt: 1, borderTop: "1px solid #d0d4d9", textAlign: "right" }}>
                                <Typography sx={{ fontWeight: "bold", fontSize: isSm ? "0.75rem" : "0.875rem", color: "#1a3c6c" }} >
                                    Applied Amt: {
                                        selectedBills
                                            .reduce(
                                                (sum, i) =>
                                                    sum + (parseFloat(i.inputAmount) || 0),
                                                0
                                            )
                                            .toFixed(2)
                                    }

                                    {paymentType !== "Advance" && (
                                        <>
                                            &nbsp; Applied TDS: {
                                                selectedBills
                                                    .reduce(
                                                        (sum, i) =>
                                                            sum + (parseFloat(i.inputTds) || 0),
                                                        0
                                                    )
                                                    .toFixed(2)
                                            }

                                            &nbsp; Applied RoundOff: {
                                                selectedBills
                                                    .reduce(
                                                        (sum, i) =>
                                                            sum + (parseFloat(i.inputRoundOff) || 0),
                                                        0
                                                    )
                                                    .toFixed(2)
                                            }

                                            &nbsp; Applied Total: {
                                                selectedBills
                                                    .reduce(
                                                        (sum, i) =>
                                                            sum +
                                                            (
                                                                (parseFloat(i.inputAmount) || 0) +
                                                                (parseFloat(i.inputTds) || 0) +
                                                                (parseFloat(i.inputRoundOff) || 0)
                                                            ),
                                                        0
                                                    )
                                                    .toFixed(2)
                                            }
                                        </>
                                    )}
                                </Typography>
                            </Box>
                        )}

                        {/* Footer Buttons */}
                        <Box sx={{ textAlign: "center", mt: 1.5 }}>
                            <Button variant="contained" size="small" sx={{ mr: 1.5, fontSize: "0.875rem" }} onClick={handleSave} disabled={disableSave || isAdvanceViewMode}>
                                Save
                            </Button>
                            <Button variant="outlined" size="small" sx={{ fontSize: "0.875rem" }} onClick={handleClear}>
                                Cancel
                            </Button>
                        </Box>
                    </Paper>
                </Grid>
            )
            }

            <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="lg" fullWidth >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 18px 0px 18px" }} >
                    <Typography fontWeight="bold">
                        Pending Invoices
                    </Typography>

                    <Typography sx={{ fontWeight: 500 }}>
                        Amount: {parseFloat(amount || 0).toFixed(2)}
                    </Typography>
                </Box>


                <DialogContent sx={{ height: "80vh", display: "flex", flexDirection: "column", p: 2 }} >

                    {isMobile ? (
                        <Box sx={{ flex: 1, overflowY: "auto" }}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1, px: 0.5, py: 0.5, bgcolor: "#f5f5f5", borderRadius: 1 }}>
                                <Checkbox size="small" checked={invoiceData.length > 0 && invoiceData.every(r => pendingSelectedIds.includes(r.invoiceId))} indeterminate={pendingSelectedIds.length > 0 && !invoiceData.every(r => pendingSelectedIds.includes(r.invoiceId))}
                                    onChange={(e) => {
                                        const allIds = invoiceData.map(r => r.invoiceId);
                                        if (e.target.checked) setPendingSelectedIds(allIds);
                                        else setPendingSelectedIds([]);
                                    }}
                                />
                                <Typography sx={{ fontSize: "0.82rem", fontWeight: 600 }}>
                                    Select All ({invoiceData.length})
                                </Typography>
                            </Box>

                            {loadingInvoices
                                ? <Typography sx={{ textAlign: "center", py: 3 }}>Loading...</Typography>
                                : invoiceData.length === 0
                                    ? <NoDataComponent />
                                    : invoiceData.map((row) => (
                                        <PendingInvoiceCard key={row.invoiceId} row={row} />
                                    ))
                            }
                        </Box>
                    ) : (
                        <DataGrid
                            rows={invoiceData ?? []}
                            columns={pendingColumns ?? []}
                            getRowId={(row) => row.invoiceId}
                            slots={{
                                noRowsOverlay: () => (
                                    <NoDataComponent />
                                ),
                            }}
                            loading={loadingInvoices}
                            rowHeight={isSm ? 48 : 52}
                            pagination
                            pageSizeOptions={[10, 20, 30]}
                            initialState={{
                                pagination: {
                                    paginationModel: { pageSize: 10, page: 0 },
                                },
                            }}
                            // HARD DISABLE SELECTION
                            rowSelection={false}              // MOST IMPORTANT
                            disableRowSelectionOnClick
                            checkboxSelection={false}
                            disableMultipleRowSelection

                            //  FORCE EMPTY SELECTION
                            rowSelectionModel={[]}
                            onRowSelectionModelChange={() => { }}

                            sx={{
                                ...dataGridSx, height: "100%",
                                '& .MuiDataGrid-selectedRowCount': { visibility: 'hidden', width: 0, },
                                // 🔽 Reduce footer height
                                '& .MuiDataGrid-footerContainer': { minHeight: 42, height: 42, overflowY: "hidden" },

                                // 🔽 Reduce pagination toolbar height
                                '& .MuiTablePagination-root': { minHeight: 42, height: 42, overflowY: "hidden" },

                                // 🔽 Reduce rows-per-page + label spacing
                                '& .MuiTablePagination-toolbar': { minHeight: 42, height: 42, padding: '0 8px', overflowY: "hidden" },
                            }}
                        />

                    )}

                    <Box
                        sx={{ mt: 1, pt: 1, borderTop: "1px solid #d0d4d9", display: "flex", justifyContent: "space-between" }} >
                        <Typography sx={{ fontWeight: "bold", color: "#1a3c6c" }}>
                            Selected O/S Total: {selectedPendingTotal.toFixed(2)}
                        </Typography>
                    </Box>


                    <Box sx={{ textAlign: "right", mt: 2 }}>
                        <Button onClick={handleSubmitSelected} disabled={pendingSelectedIds.length === 0} variant="contained" sx={{ mr: 2 }} >
                            Submit
                        </Button>

                        <Button onClick={() => setModalOpen(false)} variant="outlined" >
                            Cancel
                        </Button>
                    </Box>


                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default PaymentReceiptStepTwo;